import { Directive, HostListener, ElementRef, Input } from '@angular/core';

@Directive({ selector: '[appEnterAsTab]' })
export class EnterAsTabDirective {
    @Input('appEnterAsTab') enabled: boolean | string = true;

    constructor(private el: ElementRef<HTMLInputElement>) { }

    @HostListener('keydown.enter', ['$event'])
    onEnter(event: KeyboardEvent) {
        if (this.enabled === false || this.enabled === 'false') {
            return;
        }

        event.preventDefault();
        const form = this.el.nativeElement.form;
        if (!form) { return; }

        const elements = Array.from(form.elements) as HTMLElement[];
        const index = elements.indexOf(this.el.nativeElement);
        const next = elements[index + 1];
        if (next) {
            next.focus();
        }
    }
}
